import { useEffect } from 'react'
import Layout from '../components/Layout'
import { logPageView } from '../lib/analytics'
import BottomButton from '../components/BottomButton'
import { useRouter } from 'next/router'
import PrivacyPolicy from '../components/PrivacyPolicy'

export default function Privacy() {
  const router = useRouter()
  const query = router.query.back || '/'
  let backURL = query === 'join' ? '/join' : ''
  if (query === 'dashboard') {
    backURL = '/dashboard#profile'
  }
  if (query === 'desktop') {
    backURL = '/desktop'
  }
  if (query === 'vote-early') {
    backURL = '/'
  }

  useEffect(() => {
    logPageView('privacy')
  }, [])

  return (
    <div id="privacy">
      <Layout title="Privacy" url="privacy">
        <PrivacyPolicy />
        {backURL && (
          <BottomButton gtm="gtm-privacy" text="Go Back" href={backURL}>
            Go Back
          </BottomButton>
        )}
      </Layout>
    </div>
  )
}
